import React from 'react';

export default function OcorrenciasPage() {
  return (
    <div>
      Qualidade - Ocorrências (placeholder).
    </div>
  );
}

